import { ColoredButton } from '@components/colored-elements';
import { rbac } from '@lib/common';
import { Grid } from '@material-ui/core';
import {
  lightGreen, red, blue
} from '@material-ui/core/colors';
import CancelIcon from '@material-ui/icons/CancelRounded';
import SaveIcon from '@material-ui/icons/SaveRounded';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/DeleteRounded';
import { C2PDeleteDialog } from '../columns';
import { useToggle } from '@lib/common';
import { useSnackbar } from 'notistack';
import * as c2pService from '@api/company-person';

export function FormActions({
  submitForm = null,
  redirectToSearch = ()=>{},
  c2pFormData
}) {
  const form = useFormContext();
  const history = useHistory();
  const [editOpen, , showEditDialog, hideEditDialog] = useToggle(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSave = useCallback(() => {
    submitForm && submitForm();
  }, [submitForm]);

  const {person_company_relation_id = "", is_email_verified = false, currently_working = ''} = c2pFormData

  const onDeleteFinish = useCallback(RelationId => {
    const infoNotification = enqueueSnackbar('Please wait deleting C2P', {
      variant: 'info',
    });
    return c2pService.deleteC2P({person_company_rel_id : RelationId}).subscribe({
      next: () => {
        enqueueSnackbar('C2P deleted Successfully!', { variant: 'success' });
        redirectToSearch();
        hideEditDialog();
      },
      error: err =>
        enqueueSnackbar(`Error deleting C2P (${err})`, { variant: 'error' }),
      complete: () => closeSnackbar(infoNotification),
    });
  }, []);

  const disableDeleteBtn = is_email_verified || currently_working === 'yes';

  return (
    <Grid container spacing={2}>
      <Grid item xs>
        &nbsp;
      </Grid>
      <Grid item>
        <ColoredButton
          colored={red[500]}
          coloredHover={red[900]}
          startIcon={<CancelIcon />}
          variant="contained"
          size="small"
          // className={classes.paddingAll}
          onClick={() => history.push('/company-person/search')}>
          Cancel
        </ColoredButton>
      </Grid>
      <Grid item>
        <ColoredButton
          colored={lightGreen[700]}
          coloredHover={lightGreen[900]}
          startIcon={<SaveIcon />}
          variant="contained"
          size="small"
          disabled={rbac('C2P_Edit', '', 'Button')}
          onClick={onSave}>
          Save
        </ColoredButton>
      </Grid>
      <Grid item>
      <ColoredButton
          colored={blue[700]}
          coloredHover={blue[900]}
          startIcon={<DeleteIcon />}
          variant="contained"
          size="small"
          disabled={disableDeleteBtn ? true : rbac('C2P_Delete', '', 'Button')}
          onClick={showEditDialog}>
          Delete
        </ColoredButton>
      </Grid>
      <C2PDeleteDialog
          personCompanyRelationId={person_company_relation_id}
          onDeleteFinish={onDeleteFinish}
          deleteC2P
          open={editOpen}
          onClose={hideEditDialog}
        />
    </Grid>
  );
}
